import { Link, MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";
interface IMensajeError {
  mensaje: string;
  onDismiss: () => void;
}

export const MensajeBarError = (props: IMensajeError) => {
  return (
    <div>
      <MessageBar
        messageBarType={MessageBarType.error}
        isMultiline={false}
        onDismiss={props.onDismiss}
        dismissButtonAriaLabel="Close"
      >
        {props.mensaje}
      
      </MessageBar>
    </div>
  );
};
